/* Loufygadgets — ajoute automatiquement le Calendrier de l'Avent offert
   quand le Coffret de Noël est dans le panier, et le retire sinon. */
(function () {
  var COFFRET_PRODUCT = 15748980506948;
  var COFFRET_VARIANT = 57567754944836;
  var CAL_VARIANT = 57570856599876;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = null;

  function json(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return nativeFetch(root + url, opts).then(function (r) { return r.json(); });
  }

  // Remet à jour le tiroir panier et la pastille pour qu'ils reflètent le vrai panier
  function refreshDrawer() {
    return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
        var fresh = parse(s['cart-drawer']).querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && fresh) drawer.classList.toggle('is-empty', !fresh.querySelector('.cart-item'));
        var bubbleNew = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubbleNew && bubble) bubble.innerHTML = bubbleNew.innerHTML;
      })
      .catch(function () {});
  }

  function sync() {
    if (busy) return busy;
    busy = json('cart.js').then(function (cart) {
      var items = cart.items || [];
      var hasCoffret = items.some(function (i) {
        return i.product_id === COFFRET_PRODUCT || i.variant_id === COFFRET_VARIANT;
      });
      var cal = items.find(function (i) { return i.variant_id === CAL_VARIANT; });
      if (hasCoffret && !cal) {
        return json('cart/add.js', { items: [{ id: CAL_VARIANT, quantity: 1 }] }).then(function () { return true; });
      }
      if (!hasCoffret && cal) {
        return json('cart/change.js', { id: cal.key, quantity: 0 }).then(function () { return true; });
      }
      if (cal && cal.quantity > 1) {
        return json('cart/change.js', { id: cal.key, quantity: 1 }).then(function () { return true; });
      }
      return false;
    }).catch(function () { return false; }).then(function (changed) {
      busy = null;
      if (changed && /\/cart\/?$/.test(location.pathname)) location.reload();
      else if (changed) refreshDrawer();
      return changed;
    });
    return busy;
  }

  // Resynchronise après chaque modification du panier faite par le thème
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return nativeFetch(input, init).then(function (res) {
      if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(sync, 300);
      return res;
    });
  };

  // Avant de partir au paiement, on s'assure que le calendrier est bien là
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    sync().then(function () { location.href = root + 'checkout'; });
  }, true);

  // Sur la fiche du coffret, on masque « Acheter maintenant » (il contourne le panier)
  try {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (meta && meta.id === COFFRET_PRODUCT) {
      var s = document.createElement('style');
      s.textContent = '.shopify-payment-button{display:none!important}';
      document.head.appendChild(s);
    }
  } catch (err) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();

/* Loufygadgets — affichage de la ligne cadeau (calendrier) dans le panier :
   pas de quantité ni de poubelle, badge « Offert avec le kit », placée sous le kit.
   Uniquement du CSS : aucune donnée du panier n'est modifiée. */
(function () {
  try {
    if (document.getElementById('loufy-gift-line')) return;
    var G = 'tr.cart-item:has([data-quantity-variant-id="57570856599876"])';
    var css = [
      G + ' quantity-input,' + G + ' cart-remove-button{display:none!important}',
      G + ' .cart-item__quantity-wrapper::before{content:"🎁 Offert avec le kit";display:inline-block;background:#1f3d2b;color:#e8c977;font-weight:700;font-size:1.25rem;line-height:1.3;padding:.45rem 1.1rem;border-radius:999px;white-space:nowrap}',
      G + ' .cart-item__totals .price{font-size:0!important}',
      G + ' .cart-item__totals .price::after{content:"Offert";font-size:1.4rem;font-weight:700;color:#b3312b}',
      G + ' .cart-item__details > .product-option{display:none}',
      '.cart-drawer .cart-items tbody{display:flex;flex-direction:column}',
      G + '{order:99}',
      '@media screen and (max-width:749px){cart-items .cart-items tbody{display:flex;flex-direction:column}}'
    ].join('\n');
    var st = document.createElement('style');
    st.id = 'loufy-gift-line';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  } catch (err) {}
})();
